module.exports = __webpack_public_path__ + "static/img/DK@3x.49fda3e5.jpg";